import { Button } from '@blueprintjs/core'
import { ConnectedRouter } from 'connected-react-router'
import { auth as authentication } from 'enablex/shared'
import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { isMobile } from 'react-device-detect'

import App from '~/app'
import store, { history } from '~/app/store'
import Auth, { getActiveWorkspace, getCurrentRole } from '~/auth/basicAuth'
import ChangePassword from '~/auth/ChangePassword'
import ChatAuthResult from '~/auth/ChatAuthResult'
import LoginPage from '~/auth/Login'
import AutoLogin from '~/auth/autoLogin'
import LoginContainer from '~/auth/LoginContainer'
import RegisterPage from '~/auth/Register'
import Channels from '~/channels'
import Alerting from '~/health/alerting'
import Monitoring from '~/health/monitoring'
import Languages from '~/management/languages'
import Modules from '~/management/modules'
import Versioning from '~/management/versioning'
import LatestReleases from '~/releases/LatestReleases'
import Bots from '~/workspace/bots'
import NewBot from '~/workspace/bots/NewBot'
import Collaborators from '~/workspace/collaborators'
import AgentCollaborators from '~/workspace/agentcollaborators'
import Dashboard from '~/workspace/supervisor/dashboard'
import Branding from '~/workspace/branding'
import Departments from '~/workspace/departments'
import Logs from '~/workspace/logs'
import Roles from '~/workspace/roles'
import Workspaces from '~/workspace/workspaces'
import AppLoader from '../InjectedModuleView/AppLoader'

import { extractCookie } from './cookies'
import PrivateRoute from './PrivateRoute'
import SegmentHandler from './SegmentHandler'
import ResolutionOverLay from '../ResolutionOverLay'

const MakeMainRoutes = props => {
  const { auth } = props
  console.log('props', props)
  console.log('profile',props.profile)
  // Get role from localStorage with state to trigger re-renders
  const [currentUserRole, setCurrentUserRole] = useState(localStorage.getItem('enx/channel-web/user-role'))
  const isSupervisor = currentUserRole === 'supervisor'
  console.log('isSupervisor', isSupervisor)
  console.log('currentUserRole', currentUserRole)
  // Check for role changes periodically
  useEffect(() => {
    const checkRole = () => {
      const newRole = localStorage.getItem('enx/channel-web/user-role')
      if (newRole !== currentUserRole) {
        setCurrentUserRole(newRole)
      }
    }

    const interval = setInterval(checkRole, 500)
    return () => clearInterval(interval)
  }, [currentUserRole])

  // For now, set adminUsers to true to restore users page functionality
  // TODO: This should be determined based on actual user permissions
  const adminUsers = true
  const role = currentUserRole || ''

  const setupBranding = () => {
    window.document.title = window.APP_NAME || 'EnableX Dialogs'

    if (window.APP_FAVICON) {
        const link = document.querySelector('link[rel="icon"]')
        link && link.setAttribute('href', window.APP_FAVICON)
      }
  }

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  // setupBranding()

  const ExtractToken = () => {
    const userToken = extractCookie('userToken')
    const tokenExpiry = extractCookie('tokenExpiry')

    if (userToken) {
      authentication.setToken({
        [window.USE_JWT_COOKIES ? 'csrf' : 'jwt']: userToken,
        exp: Date.now() + Number(tokenExpiry)
      })
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth.afterLoginRedirect()

    return null
  }

  const NoAccess = () => {
    return (
      <LoginContainer subtitle={<strong>No access</strong>}>
        <p>Sorry, you do not have access to any workspace.</p>
        <Button text="Logout" onClick={auth.logout} />
      </LoginContainer>
    )
  }

  const NotAccessibleWorkspace = () => {
    return (
      <LoginContainer subtitle={<strong>No access</strong>}>
        <p>Sorry, you do not have access to this workspace.</p>
      </LoginContainer>
    )
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
    window.addEventListener('resize', handleResize)
  }, [])

  let isSmallScreen = false
  let desktopSmallScreen = false
  let deviceType = 'desktop'
  if (isMobile) {
    isSmallScreen = true
    deviceType = 'mobile'
  } else {
    desktopSmallScreen = windowDimensions.width < 768 ? true : false
    if (desktopSmallScreen) {
      isSmallScreen = true
      deviceType = 'smallDesktopScreen'
    }
  }

  return (
    <Provider store={store}>
      <SegmentHandler>
        <ConnectedRouter history={history}>
          {isSmallScreen && <ResolutionOverLay device={deviceType} /> }
          {!isSmallScreen && (
            <Switch>
              <Route path="/login/:strategy?/:workspace?" render={props => <LoginPage auth={auth} {...props} />} />
              <Route
                path="/register/:strategy?/:workspace?"
                render={props => <RegisterPage auth={auth} {...props} />}
              />
              <Route path="/setToken" component={ExtractToken} />
              <Route
                path="/autoLogin/:token?/:expiry?/:workspace?"
                component={props => <AutoLogin auth={auth} {...props} />}
              />
              <Route path="/changePassword" render={props => <ChangePassword auth={auth} {...props} />} />
              <Route path="/noAccess" component={NoAccess} />
              <Route path="/notAccessibleWorkspace" component={NotAccessibleWorkspace} />
              <Route path="/chatAuthResult" component={ChatAuthResult} />
              <PrivateRoute path="/" auth={auth} component={App}>
                <Switch>
                  {/* <Route path="/latestReleases" component={LatestReleases} /> */}
                  {/* <Route path="/server/monitoring" component={Monitoring} /> */}
                  {/* <Route path="/server/version" component={Versioning} /> */}
                  <Route path="/server/languages" component={Languages} />
                  {/* <Route path="/server/alerting" component={Alerting} /> */}
                  <Route path="/channels" component={Channels} />
                  <Route path="/workspace/:workspaceId?/bots" component={Bots} />
                  { adminUsers &&
                  (<Route path="/workspace/:workspaceId?/newBot" component={NewBot} />)
                  }
                  { adminUsers &&
                  (<Route path="/workspace/:workspaceId?/users" component={Collaborators} />)
                  }
                  { role === 'agent' &&
                  (<Route path="/workspace/:workspaceId?/stats" component={AgentCollaborators} />)
                  }
                  { isSupervisor &&
                  (<Route path="/workspace/:workspaceId?/dashboard" component={Dashboard} />)
                  }
                  { adminUsers &&
                  (<Route path="/workspace/:workspaceId?/branding" component={Branding} />)
                  }
                  { adminUsers &&
                  (<Route path="/workspace/:workspaceId?/departments" component={Departments} />)
                  }
                  {/* <Route path="/workspace/:workspaceId?/logs" component={Logs} /> */}
                  <Route path="/workspaces" component={Workspaces} />
                  <Route path="/apps/:appName/:botId" component={AppLoader} />
                  <Route path="/apps/:appName/:botId/sessions" component={AppLoader} />
                  {/* <Route path="/modules" component={Modules} /> */}
                  <Route path="/" render={() => {
                    const workspaceId = getActiveWorkspace()

                    // Redirect supervisors to dashboard, others to bots
                    if (isSupervisor) {
                      return <Redirect from="/" to={`/workspace/${workspaceId}/dashboard`} />
                    } else {
                      return <Redirect from="/" to={`/workspace/${workspaceId}/bots`} />
                    }
                  }} />
                </Switch>
              </PrivateRoute>
            </Switch>
          )}
        </ConnectedRouter>
      </SegmentHandler>
    </Provider>
  )
}

export default MakeMainRoutes
